import { useState, useCallback } from "react";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";

const useHubspotStatus = (domainId) => {
  const [hasHubspotCredentials, setHasHubspotCredentials] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkHubspotCredentials = useCallback(async () => {
    if (!domainId) {
      // console.log("No domain ID provided");
      return false;
    }

    try {
      setIsLoading(true);

      const credentialsRes = await axios
        .get(`${FAST_API_BASE_URL}/api/mcp-credentials/hubspot`, {
          headers: { "DOMAIN-TOKEN": domainId },
        })
        .catch(() => ({ data: { result: null } }));

      const credentials = credentialsRes?.data;
      // console.log("Hubspot credentials response:", credentials);

      const hasValidCredentials =
        credentials?.resultCode === "0" &&
        credentials?.resultType === "Success";

      // console.log("Hubspot credentials check result:", hasValidCredentials);
      setHasHubspotCredentials(hasValidCredentials);

      return hasValidCredentials;
    } catch (err) {
      console.error("Failed to check Hubspot credentials:", err);
      setHasHubspotCredentials(false);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [domainId]);

  return {
    hasHubspotCredentials,
    isLoading,
    checkHubspotCredentials,
    setHasHubspotCredentials,
  };
};

export default useHubspotStatus;